import type { SVGProps } from "react";
export interface CoffeeBeansIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CoffeeBeansIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CoffeeBeansIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.087 11.19a1.125 1.125 0 0 1 2.186.534c-.107.436-.136.942.02 1.523.275 1.026.947 1.547 1.976 2.291.984.71 2.324 1.645 2.83 3.532.265.988.22 1.881.034 2.641l-.032.111a1.126 1.126 0 0 1-2.153-.646l.064-.34a3 3 0 0 0-.085-1.183c-.275-1.026-.947-1.547-1.976-2.291-.922-.666-2.159-1.529-2.726-3.189l-.104-.343a5.25 5.25 0 0 1-.034-2.64m-4.18-9.9a1.126 1.126 0 0 1 .516 2.187l-.326.116a3 3 0 0 0-.982.665c-.75.751-.866 1.593-.996 2.856-.116 1.132-.245 2.634-1.399 3.955l-.244.263a5.25 5.25 0 0 1-2.27 1.349l-.114.026a1.125 1.125 0 0 1-.517-2.187l.327-.114c.33-.137.663-.346.983-.665l.133-.142c.632-.716.742-1.53.863-2.715.124-1.207.262-2.835 1.643-4.217l.274-.258A5.2 5.2 0 0 1 9.795 1.32l.111-.028Z"
      />
      <path
        fill={color}
        d="M15.863 9.93c1.555-.416 3.108.057 4.333 1.004 1.224.946 2.18 2.4 2.64 4.116.46 1.717.359 3.453-.228 4.884-.588 1.433-1.697 2.619-3.251 3.035-1.554.417-3.106-.056-4.332-1.003-1.224-.946-2.18-2.4-2.64-4.116-.46-1.717-.36-3.453.228-4.884.588-1.433 1.696-2.619 3.25-3.035Zm2.956 2.784c-.799-.617-1.641-.805-2.373-.61-.731.197-1.368.78-1.752 1.716s-.48 2.165-.136 3.448c.344 1.284 1.042 2.3 1.843 2.918s1.643.805 2.375.61c.73-.197 1.366-.781 1.75-1.716.384-.936.48-2.164.136-3.448s-1.042-2.3-1.843-2.918M7.52.931c1.535-.207 3.115.159 4.253 1.296s1.505 2.72 1.298 4.254-.988 3.088-2.244 4.345-2.812 2.037-4.345 2.244c-1.534.207-3.116-.16-4.254-1.298S.724 9.054.931 7.52s.987-3.088 2.244-4.345S5.986 1.138 7.52.93Zm.3 2.23c-1.002.135-2.114.665-3.053 1.605S3.297 6.817 3.161 7.82c-.135 1.001.123 1.826.658 2.361s1.36.795 2.361.66c1.003-.136 2.116-.666 3.056-1.606s1.47-2.053 1.605-3.056c.136-1.001-.123-1.826-.659-2.361-.535-.535-1.36-.793-2.361-.658Z"
      />
    </svg>
  );
}
